import { ScheduleIntroductionContentAfter } from "slot-definitions"
import { OverarchingIntroduction } from "routes/schedule/plugins/overarching-introduction/overarching-introduction"

ScheduleIntroductionContentAfter.plug(<OverarchingIntroduction $lazy />)
